import api from './api'

export const tenantSettingsService = {
  // Get current tenant's settings (tenant admin only)
  async getSettings() {
    try {
      const response = await api.get('/tenants/settings')
      return response.data
    } catch (error) {
      console.error('Error getting tenant settings:', error)
      throw error
    }
  },

  // Update current tenant's settings (tenant admin only)
  async updateSettings(settings) {
    try {
      const response = await api.put('/tenants/settings', { settings })
      return response.data
    } catch (error) {
      console.error('Error updating tenant settings:', error)
      throw error
    }
  },

  // Lightweight branding read (#34) - available to ANY authenticated tenant
  // member (not just admins), used by BrandingContext to render app chrome.
  async getBranding() {
    try {
      const response = await api.get('/tenants/branding')
      return response.data
    } catch (error) {
      console.error('Error getting tenant branding:', error)
      throw error
    }
  },

  // Set/clear the separate billing contact (#378). Pass null to clear.
  async updateBillingContact(billingContact, { addAsUser = false } = {}) {
    try {
      const response = await api.put('/tenants/billing-contact', {
        billingContact,
        ...(addAsUser && { billingContactAddAsUser: true }),
      })
      return response.data
    } catch (error) {
      console.error('Error updating billing contact:', error)
      throw error
    }
  },

  // SSO Methods

  // Get SSO configuration for current tenant
  async getSsoConfig() {
    try {
      const response = await api.get('/tenants/sso')
      return response.data
    } catch (error) {
      console.error('Error getting SSO config:', error)
      throw error
    }
  },

  // Configure SSO for current tenant
  async configureSso(config) {
    try {
      const response = await api.put('/tenants/sso', config)
      return response.data
    } catch (error) {
      console.error('Error configuring SSO:', error)
      throw error
    }
  },

  // Delete SSO configuration
  async deleteSso() {
    try {
      const response = await api.delete('/tenants/sso')
      return response.data
    } catch (error) {
      console.error('Error deleting SSO config:', error)
      throw error
    }
  },

  // Get SP metadata for IdP configuration
  async getSsoMetadata() {
    try {
      const response = await api.get('/tenants/sso/metadata')
      return response.data
    } catch (error) {
      console.error('Error getting SSO metadata:', error)
      throw error
    }
  }
}

export default tenantSettingsService
